package com.rosario.juridico.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CalendarToday
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import kotlinx.browser.document
import kotlinx.datetime.LocalDate
import org.w3c.dom.HTMLInputElement

@Composable
actual fun JuridicoDatePicker(
    value: LocalDate?,
    label: String,
    modifier: Modifier,
    onValueChange: (LocalDate) -> Unit
) {
    Box(modifier = modifier) {
        OutlinedTextField(
            value = value?.let { "${it.dayOfMonth}/${it.monthNumber}/${it.year}" } ?: "",
            onValueChange = {},
            readOnly = true,
            label = { Text(label) },
            trailingIcon = { Icon(Icons.Default.CalendarToday, null) },
            modifier = Modifier.fillMaxWidth()
        )
        // Capa invisible que dispara el input HTML nativo
        Box(
            modifier = Modifier
                .matchParentSize()
                .clickable {
                    showNativeWebDatePicker(onSelected = { onValueChange(it) })
                }
        )
    }
}

@Composable
actual fun JuridicoDatePickerDialogKMP(
    onDateSelected: (LocalDate) -> Unit,
    onDismiss: () -> Unit
) {
    // Al ser Skia Web, no podemos usar Dialogs de Compose para el calendario
    // porque rompen la jerarquía. Disparamos el nativo y notificamos.
    LaunchedEffect(Unit) {
        showNativeWebDatePicker(
            onSelected = { 
                onDateSelected(it)
            },
            onCancel = onDismiss
        )
    }
}

@Composable
actual fun JuridicoMonthYearPicker(
    initialDate: LocalDate,
    onDateSelected: (LocalDate) -> Unit,
    onDismiss: () -> Unit
) {
    // El input type="month" es nativo en navegadores modernos
    LaunchedEffect(Unit) {
        showNativeWebDatePicker(
            type = "month",
            onSelected = {
                onDateSelected(it)
            },
            onCancel = onDismiss
        )
    }
}

/**
 * Lógica auxiliar para interactuar con el DOM y disparar el selector nativo.
 */
private fun showNativeWebDatePicker(
    type: String = "date",
    onSelected: (LocalDate) -> Unit,
    onCancel: () -> Unit = {}
) {
    val input = document.createElement("input") as HTMLInputElement
    input.type = type
    input.style.display = "none"
    input.style.position = "fixed"
    input.style.top = "0"
    
    document.body?.appendChild(input)

    input.onchange = {
        val dateVal = input.value
        if (dateVal.isNotEmpty()) {
            try {
                val parts = if (type == "month") {
                    // Formato YYYY-MM
                    val p = dateVal.split("-")
                    listOf(p[0], p[1], "1")
                } else {
                    // Formato YYYY-MM-DD
                    dateVal.split("-")
                }
                onSelected(LocalDate(parts[0].toInt(), parts[1].toInt(), parts[2].toInt()))
            } catch (e: Exception) {
                console.error("Error parseando fecha: $e")
            }
        }
        document.body?.removeChild(input)
    }

    input.onblur = {
        // Fallback para cuando el usuario cierra el picker sin seleccionar nada
        onCancel()
    }

    // Disparar click/picker
    try {
        input.asDynamic().showPicker()
    } catch (e: Exception) {
        input.click()
    }
}
